import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Shimmer } from 'react-shimmer';
import useResizeObserver from 'hooks/use_resize_observer';

import './styles.scss';

export default function LoadingShimmer({ className }) {
  const [width, setWidth] = useState();
  const [height, setHeight] = useState();

  const ref = useResizeObserver(({ height, width }) => {
    setWidth(width);
    setHeight(height);
  });

  return (
    <div className={classNames('loading-shimmer', className)} ref={ref}>
      <Shimmer height={height || 0} width={width || 0} />
    </div>
  );
}

LoadingShimmer.propTypes = {
  className: PropTypes.string,
};
